import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;

// httpOnly cookie auth: axios must send cookies with every request.
export const api = axios.create({ baseURL: API_BASE, withCredentials: true });

// Read a cookie value by name — used for the CSRF double-submit pattern.
function readCookie(name) {
  const m = document.cookie.match(new RegExp("(?:^|; )" + name.replace(/([.$?*|{}()[\]\\/+^])/g, "\\$1") + "=([^;]*)"));
  return m ? decodeURIComponent(m[1]) : "";
}

// Echo the non-httpOnly `mazad_csrf` cookie in the `X-CSRF-Token` header on every
// state-changing request. This is the double-submit-cookie CSRF mitigation.
api.interceptors.request.use((config) => {
  const method = (config.method || "get").toLowerCase();
  if (method !== "get" && method !== "head" && method !== "options") {
    const csrf = readCookie("mazad_csrf");
    if (csrf) config.headers["X-CSRF-Token"] = csrf;
  }
  return config;
});

export function wsUrl(path) {
  const httpUrl = new URL(BACKEND_URL);
  const protocol = httpUrl.protocol === "https:" ? "wss:" : "ws:";
  return `${protocol}//${httpUrl.host}/api${path}`;
}

export const formatAED = (n) =>
  new Intl.NumberFormat("en-AE", { maximumFractionDigits: 0 }).format(Math.round(Number(n) || 0));

/**
 * Turn any axios error into a readable string.
 *
 * FastAPI returns 422 validation errors as a list of dicts
 * (`[{type, loc, msg, input, url}]`). Older callers `toast.error`ing the
 * raw `detail` field crash React ("Objects are not valid as a React
 * child"). This helper flattens all common shapes into a plain string.
 */
export function errMsg(err, fallback = "Something went wrong") {
  const d = err?.response?.data?.detail;
  if (!d) return err?.message || fallback;
  if (typeof d === "string") return d;
  if (Array.isArray(d)) {
    // Pydantic v2: [{type, loc, msg, input, url}]
    return d.map((e) => {
      const field = Array.isArray(e?.loc) ? e.loc.filter((p) => p !== "body").join(".") : "";
      const msg = e?.msg || "Invalid value";
      return field ? `${field}: ${msg}` : msg;
    }).join("; ") || fallback;
  }
  if (typeof d === "object") return d.msg || d.message || JSON.stringify(d);
  return String(d);
}

/**
 * Derived display status for an auction lot. The DB uses "ended" for any
 * finalised lot regardless of whether it sold or ended without bids, but
 * customer-facing surfaces should show "sold" when a winner was marked.
 * Admin surfaces use the same helper so ops sees the outcome at a glance.
 */
export function lotDisplayStatus(lot) {
  if (!lot) return "scheduled";
  if (lot.status === "ended" && lot.winner_id) return "sold";
  return lot.status;
}

